import React from "react";
import { t } from "../../../utils/i18n";
import { DATE_ACTIVITIES } from "../../../utils/dateActivities";

export default function ActivityStep({ lang, value, onSelect }: { lang: string; value: string | null; onSelect: (key: string) => void }) {
  return (
    <div>
      <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 4 }}>{t(lang, "date_step_activity_title")}</div>
      <div style={{ fontSize: 12.5, color: "#999", marginBottom: 16 }}>{t(lang, "date_step_activity_sub")}</div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
        {DATE_ACTIVITIES.map(a => {
          const selected = value === a.key;
          const Icon = a.Icon;
          return (
            <button
              key={a.key}
              onClick={() => onSelect(a.key)}
              style={{
                display: "flex", flexDirection: "column", alignItems: "center", gap: 8,
                padding: "14px 6px", borderRadius: 14, cursor: "pointer",
                border: selected ? "1.5px solid #0a0a0a" : "1px solid #eee",
                backgroundColor: selected ? "#fafafa" : "white",
              }}
            >
              <Icon size={20} color="#111" strokeWidth={1.7} />
              <span style={{ fontSize: 11, fontWeight: 600, color: "#333", textAlign: "center", lineHeight: 1.2 }}>{t(lang, a.i18nKey)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
